import React from 'react';
import RadioComponent from 'pu-react/components/RadioComponent';

const RigidFlexSelector = (props) => {
  const name = 'rigid_flex_selector';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <div className="form-group">
      <RadioComponent
        name={name}
        label="Flex"
        value="Flex"
        checked={props.parameters[name] === 'Flex'}
        onChange={onChange}
        inputId="rigid-flex-selector-flex"
        inline
        groupName={props.groupName} />
      <RadioComponent
        name={name}
        label="Rigid Flex"
        value="Rigid Flex"
        checked={props.parameters[name] === 'Rigid Flex'}
        onChange={onChange}
        inputId="rigid-flex-selector-rigid-flex"
        inline
        groupName={props.groupName} />
      <div id="error_rigid_flex_selector" />
    </div>
  );
};

export default RigidFlexSelector;
